const data = {
	"width": 40,
	"height": 40,
	"body": "<path fill=\"currentColor\" d=\"M32.666 13.25H7.334a.5.5 0 0 1 0-1h25.332a.5.5 0 0 1 0 1zm0 7.25H7.334a.5.5 0 0 1 0-1h25.332a.5.5 0 0 1 0 1zm0 7.25H7.334a.5.5 0 0 1 0-1h25.332a.5.5 0 0 1 0 1z\"/>"
};
exports.__esModule = true;
exports.default = data;
